import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "search-container"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "search-img-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://m.media-amazon.com/images/G/28/NewApp/00_EN/Gateway_Top_Search.jpg"
})], -1);
import { useRouter } from 'vue-router';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
export default {
  __name: 'SearchWidget',
  setup(__props) {
    useLess('views/landingPage/searchWidget/SearchWidget.less');
    var GATEWAY_TOP_SEARCH_ICON = imageLink.GATEWAY_TOP_SEARCH_ICON;
    var router = useRouter();
    var onClickLogo = () => {
      window.location.reload();
    };
    var onClickInput = () => {
      router.push({
        name: 'search'
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        class: "search-trigger-area"
      }, [_createElementVNode("div", {
        class: "search-trigger-logo",
        onClick: onClickLogo
      }), _createElementVNode("div", {
        class: "search-trigger-input",
        onClick: onClickInput
      })])]);
    };
  }
};